import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import { getCurrentCompnaySelected } from "store/actions"
import { useDispatch } from "react-redux"
import { GET_VENDOR_SUPPLY_STATE } from "helpers/url_helper"
import { get, post } from "helpers/api_helper"
const CompanyDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const company = authUser?.org ? authUser?.company?.org_company : authUser?.company?.contact_company
  const defaultCompany = company.length ? company[0].id : 0
  const [selectedCompany, setSelectedCompany] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    const data = localStorage.getItem("SELECTED_COMPANY")
    if (!data) {
      dispatch(getCurrentCompnaySelected(defaultCompany))
      localStorage.setItem("SELECTED_COMPANY", defaultCompany)
      setSelectedCompany(defaultCompany)
    } else {
      dispatch(getCurrentCompnaySelected(data))
      setSelectedCompany(data)
    }
    get(GET_VENDOR_SUPPLY_STATE + `${selectedCompany}`).then(res => {
      if (res.status === 200) {
        localStorage.setItem("SELECTED_COMPANY_SUPPLY_STATE_ID", res.data.supply_state_id)
        localStorage.setItem("SELECTED_COMPANY_SUPPLY_STATE", res.data.supply_state)
      }
    })
  }, [company])

  const changeCompanyAction = lang => {
    dispatch(getCurrentCompnaySelected(lang))
    localStorage.setItem("SELECTED_COMPANY", lang)
    setSelectedCompany(lang)
  }

  const toggle = () => {
    setMenu(!menu)
  }

  const companyName = (id) => {
    return company.map(data => {
      if (data.id == id) {
        return data.company_name
      }
    })
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-none d-md-block ms-2">
        <DropdownToggle className="btn header-item waves-effect" tag="button">
          {companyName(selectedCompany)}
          <span className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {company.map(data =>
            <DropdownItem
              key={data.id}
              onClick={() => changeCompanyAction(data.id)}
              className={`notify-item ${selectedCompany === data.id ? "active" : "none"}`}>
              <span className="align-middle">
                {data.company_name}
              </span>
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown >
    </>
  )
}

export default withTranslation()(CompanyDropdown)
